import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MaterialModule } from 'src/app/material.module';
import { CasehistoryComponent } from "./opddetails/opddetail.component";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormsModule } from '@angular/forms';
import { MY_FORMATS } from 'src/app/common/dateFormat';
import { Location } from '@angular/common';
import { OPDService } from './opd.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SelectionService } from 'src/app/services/selection.service';
import { PatientService } from '../patient/patient.service';
import { GenderList } from 'src/app/common/types/common';
import { UserService } from '../user/user.service';
import { environment } from 'src/environments/environment';
import { FallbackImageDirective } from 'src/app/common/directive/fallback-image.directive';
import { CommonDropDown } from 'src/app/common/types/dropdown.type';
import { Iopd, SideMenu } from './opddetails/iopddetails';
import { IPatientInfo } from '../patient/ipatient-info';
import { IUsers } from '../user/iusers';
import { PrescriptionComponent } from './prescription/prescription.component';
import { AppointmentStatusType, AppointmentStatusTypeLabels } from 'src/app/common/enums/appointment-status-type';
import { AppointmentService } from '../appointment/appointment.service';
import { Appointment } from '../appointment/iappointment';
import { PatientReportPrintComponent } from '../dialogs/patient-report-print/patient-report-print.component';
import { CategoryType, CategoryTypeLabels } from 'src/app/common/enums/category-type';
import { ToastrService } from 'ngx-toastr';
import { catchError, filter, map, Observable, of, switchMap, take, tap } from 'rxjs';
import { AppointmentDialog } from '../dialogs/confirmation-appointment/appointment-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from 'src/app/login.service';
import { IpdFormComponent } from '../ipd/ipd-form/ipd-form.component';
import { BillDialogData } from '../dialogs/bill/bill-dialog-data.interface';
import { BillType } from 'src/app/common/enums/bill-type';
import { AddBillChargeComponent } from '../dialogs/bill/bill.component';
import { LoaderComponent } from 'src/app/shared/loader/loader.component';
import { PatientViewComponent } from '../patient/patient-view/patient-view.component';

@Component({
  selector: 'app-opd',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    MatInputModule,
    TablerIconsModule,
    NgScrollbarModule,
    RouterModule,
    CasehistoryComponent,
    FormsModule,
    TranslateModule,
    FallbackImageDirective,
    PrescriptionComponent,
    PatientReportPrintComponent,
    LoaderComponent
  ],
  templateUrl: './opd.component.html',
  styleUrl: './opd.component.scss',
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class OPDComponent implements OnInit {

  newvalue: boolean = false;
  sidePanelOpened = signal(true);
  selectedComponent: string = 'CaseHistory';
  showSelectedFirst: boolean = true;
  private mediaMatcher: MediaQueryList = matchMedia(`(max-width: 960px)`);
  maxDate: Date = new Date();
  OPDDate: Date;
  OpdData: Iopd | null;
  patientinfo: IPatientInfo;
  doctorDetails: IUsers;
  staticimagepath: string = environment.imagePath;
  defaultAvatarPath = 'assets/images/profile/user-1.jpg';
  selectedsubcategory: CommonDropDown | undefined;
  selectedcategory: CommonDropDown | undefined;
  isFirstTab = false;
  isLastTab = false;
  appointmentData: Appointment;
  private opdCompleted = false;
  public statusList = AppointmentStatusTypeLabels;
  isIPD: boolean = false;
  isLoading: boolean = false;
  @ViewChild(CasehistoryComponent) caseHistory!: CasehistoryComponent;

  public readonly categoryTabs = new Set<string>([
    'CaseHistory',
    'ClinicalExam',
    'SuggestedInvestigation',
    'Diagnosis'
  ]);

  ListOfSideMenu: SideMenu[] = [
    {
      id: 1,
      name: CategoryTypeLabels[CategoryType.CaseHistory],
      icon: 'library',
      link: 'CaseHistory',
    },
    {
      id: 2,
      name: CategoryTypeLabels[CategoryType.ClinicalExam],
      icon: 'school',
      link: 'ClinicalExam',
    },
    {
      id: 3,
      name: CategoryTypeLabels[CategoryType.SuggestedInvestigation],
      icon: 'search',
      link: 'SuggestedInvestigation',
    },
    {
      id: 4,
      name: CategoryTypeLabels[CategoryType.Diagnosis],
      icon: 'affiliate',
      link: 'Diagnosis',
    },
    {
      id: 5,
      name: this.translate.instant('ENTITY.PRESCRIPTION'),
      icon: 'prescription',
      link: 'Prescription',
    },
    {
      id: 6,
      name: this.translate.instant('LABEL.PATIENT_REPORT'),
      icon: 'report',
      link: 'PatientReport',
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private opdService: OPDService,
    private router: Router,
    private selectionService: SelectionService,
    private patientService: PatientService,
    private userService: UserService,
    private _appointmentService: AppointmentService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private _loginService: LoginService
  ) { }

  isOver(): boolean {
    return window.innerWidth < 1199;
  }

  ngOnInit(): void {
    this.isIPD = this._loginService.isIPDTabShown();

    this.route.paramMap.subscribe(params => {
      this.resetOPDState();
      this.isLoading = true;

      const patientId = Number(params.get('patientId'));
      const opdId = Number(params.get('opdId'));

      if (patientId) {
        this.patientService.getPatientByID(patientId).subscribe(res => {
          this.patientinfo = res.result;
        });
      }

      if (opdId) {
        this.loadOPDDetails(opdId);
      }
    });
  }

  private loadOPDDetails(opdId: number): void {
    this.opdService.getOPDById(opdId).subscribe({
      next: (response) => {
        this.OpdData = response.result;

        this.userService.getUserByID(Number(this.OpdData?.doctorId))
          .subscribe(res => {
            this.doctorDetails = res.result;
          });

        if (this.OpdData?.appointmentId) {
          this._appointmentService.getAppointmentById(this.OpdData.appointmentId)
            .subscribe(res => {
              this.appointmentData = res.result;
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      },
      error: () => this.isLoading = false
    });
  }

  private resetOPDState(): void {
    this.OpdData = null!;
    this.patientinfo = null!;
    this.doctorDetails = null!;
    this.appointmentData = null!;
    this.selectedComponent = 'CaseHistory';
    this.opdCompleted = false;
  }

  selectedtab(select: string) {
    this.selectedComponent = select;
    this.updateButtonVisibility();
  }

  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Prevent the default context menu
    // Add your custom logic here
  }

  goBack() {
    const selection = this.selectionService.value();
    if (selection?.doctorId && selection?.appointmentDate) {
      this.router.navigate(['/appointment']);
    } else {
      this.location.back();
    }
  }

  getCurrentMenuTitle(): string {
    const currentMenu = this.ListOfSideMenu.find(menu => menu.link === this.selectedComponent);
    return currentMenu ? currentMenu.name : CategoryTypeLabels[CategoryType.CaseHistory];
  }

  updateButtonVisibility(): void {
    const currentIndex = this.ListOfSideMenu.findIndex(menu => menu.link === this.selectedComponent);
    this.isFirstTab = currentIndex === 0;
    this.isLastTab = currentIndex === this.ListOfSideMenu.length - 1;
  }

  goToPrevious(): void {
    const currentIndex = this.ListOfSideMenu.findIndex(menu => menu.link === this.selectedComponent);
    if (currentIndex > 0) {
      this.selectedComponent = this.ListOfSideMenu[currentIndex - 1].link;
      this.updateButtonVisibility();
    }
  }

  goToNext(): void {
    const currentIndex = this.ListOfSideMenu.findIndex(menu => menu.link === this.selectedComponent);
    if (currentIndex < this.ListOfSideMenu.length - 1) {
      this.selectedComponent = this.ListOfSideMenu[currentIndex + 1].link;
      this.updateButtonVisibility();
    }
  }

  getGenderName(value?: string): string {
    const gender = GenderList.find(g => g.value === value);
    return gender ? gender.name : '';
  }

  get profileImagePathSrc(): string {
    if (this.patientinfo?.profileImagePath) {
      return this.staticimagepath + this.patientinfo.profileImagePath;
    }
    return this.defaultAvatarPath;
  }

  // onItemAdd() {
  //   const selectedCategory = this.caseHistoryComponent?.selectedcategory ?? null;
  //   const selectedSubcategory = this.caseHistoryComponent?.selectedsubcategory || null;

  //   const dialogRef = this.dialog.open(ClinicalitemDetailComponent, {
  //     autoFocus: false,
  //     width: '700px',
  //     height: 'auto',
  //     data: {
  //       fromOPD: true,
  //       categoryvalue: selectedCategory,
  //       Subcategoryvalue: selectedSubcategory
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       this.reloadCategoriesAndItems(selectedCategory?.id);
  //     }
  //   });
  // }

  // reloadCategoriesAndItems(preserveCategoryId?: number) {
  //   if (this.caseHistoryComponent?.reloadCategoriesAndItems) {
  //     this.caseHistoryComponent.reloadCategoriesAndItems(preserveCategoryId);
  //   }
  // }
  canExitOPD(): Observable<boolean> | boolean {
    if (this.opdCompleted) {
      return true;
    }

    return this.confirmExitOPD().pipe(
      switchMap(result => {
        if (!result) {
          return of(false);
        }

        if (this.OpdData?.appointmentId && this.appointmentData) {
          return this.updateStatusOfOPD().pipe(
            map(success => success === true)
          );
        }
        // No appointment → just allow navigation
        return of(true);
      })
    );
  }

  finishOPD(): void {
    if (!this.OpdData?.appointmentId || !this.appointmentData) {
      return;
    }

    if (!this.isIPD) {
      this.finishAndNavigateToAppointment().subscribe();
      return;
    }

    const dialogRef = this.dialog.open(AppointmentDialog, {
      width: '400px',
      data: {
        message: this.translate.instant('APPOINTMENT_RELATED.IPD_ADMIT'),
        title: this.translate.instant('ENTITY.IPD')
      }
    });

    dialogRef.afterClosed().pipe(
      take(1),
      switchMap(result => {
        if (result === 'yes') {
          return this.updateStatusOfOPD().pipe(
            filter(success => success),
            tap(() => this.admitToIpd())
          );
        }
        return this.finishAndNavigateToAppointment();
      })
    ).subscribe();
  }

  private finishAndNavigateToAppointment(): Observable<boolean> {
    return this.updateStatusOfOPD().pipe(
      take(1),
      filter(success => success),
      tap(() => {
        this.router.navigate(['/appointment']);
      })
    );
  }

  updateStatusOfOPD(): Observable<boolean> {
    const updatedAppointment = {
      ...this.appointmentData,
      status: AppointmentStatusType.Attended
    };
    return this._appointmentService.updateAppointment(updatedAppointment).pipe(
      tap(response => {
        if (response.isSuccess) {
          this.opdCompleted = true;
          return;
        }
        if (response.errors) {
          const allErrors = Object.values(response.errors).flat();
          this.toastr.error(allErrors.join('\n'));
        }
      }),
      map(response => response.isSuccess === true),
      catchError(() => {
        this.toastr.error('Failed to update OPD status');
        return of(false);
      })
    );
  }

  private confirmExitOPD(): Observable<boolean> {
    const statusEnum = this.AppointmentStatus(this.appointmentData.status);

    if (statusEnum !== AppointmentStatusType.InProgress) {
      return of(true);
    }
    return this.dialog.open(AppointmentDialog, {
      disableClose: true,
      data: {
        title: this.translate.instant('OPD_EXIT_TITLE'),
        message: this.translate.instant('OPD_EXIT')
      }
    }).afterClosed().pipe(
      map(result => result === 'yes')
    );
  }

  private AppointmentStatus(status: AppointmentStatusType | string): AppointmentStatusType | null {
    if (typeof status === 'string') {
      return AppointmentStatusType[status as keyof typeof AppointmentStatusType];
    }
    return status;
  }

  admitToIpd() {
    if (this.OpdData?.ipdId) {
      this.router.navigate(['/ipd/admit', this.OpdData.ipdId, 'patient', this.patientinfo?.id,]);
    } else {
      this.dialog.open(IpdFormComponent, {
        height: '65vh',
        minWidth: '55vw',
        disableClose: true,
        data: {
          OPDDetails: this.OpdData
        }
      }).afterClosed().subscribe((result) => {
        if (result) {
        }
      });
    }
  }

  get isAppointmentAttended(): boolean {
    if (!this.appointmentData?.status) {
      return false;
    }
    const statusEnum = this.AppointmentStatus(this.appointmentData.status);
    return statusEnum === AppointmentStatusType.Attended;
  }

  OnBillOPD() {
    if (this.appointmentData?.billId) {
      this.openBillChargeDialog();
      return;
    }
    const statusNumber = AppointmentStatusType[this.appointmentData?.status as any as keyof typeof AppointmentStatusType];
    if (statusNumber !== AppointmentStatusType.InProgress) {
      this.openBillChargeDialog();
      return;
    }

    const dialogRef = this.dialog.open(AppointmentDialog, {
      width: '400px',
      data: {
        message: this.translate.instant('APPOINTMENT_RELATED.PRINT_BILL_CONFIRMATION'),
        title: this.translate.instant('ENTITY.APPOINTMENT')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.openBillChargeDialog();
      }
    });
  }

  private openBillChargeDialog() {
    const dialogData: BillDialogData = {
      billType: BillType.OPDBill,
      opdBillData: {
        ...this.appointmentData,
        patientName: `${this.patientinfo?.firstName} ${this.patientinfo?.lastName}`
      },
      selectedDoctorId: this.doctorDetails.id
    };

    this.dialog.open(AddBillChargeComponent, {
      autoFocus: false,
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: ['bill-dialog', 'side-panel'],
      data: dialogData
    }).afterClosed().subscribe(result => {
      if (result && this.appointmentData) {
        this.appointmentData.billId = result;
      }
    });
  }

  viewPatientDetails(element: IPatientInfo): void {
    this.dialog.open(PatientViewComponent, {
      autoFocus: false,
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      data: {
        patient: element,
      }
    }).afterClosed().subscribe();
  }

}